<template>
  <div
    class="radio-item"
    :class="{ 'radio-item-active': value == checked }"
    :style="{ width: getWidth(rows) }"
    @click="bindCheck"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String | Number,
      default: ''
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      checked: false
    }
  },
  created() {
    this.$parent && this.$parent.updateChildren()
  },
  methods: {
    getWidth(num) {
      let space = 2.4
      let width = (100 - space * (num - 1)) / num
      return width.toFixed(2) + '%'
    },
    bindCheck() {
      this.$parent && this.$parent.updateCheck(this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.radio-item {
  width: 100%;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  font-size: 13px;
  color: #8E8D9B;
  line-height: 22px;
  box-sizing: border-box;
  margin-bottom: 10px;
  overflow: hidden;
}
.radio-item-active {
  color: #fe0932;
}
</style>
